import { doRequest } from '@r1-frontend/do-request';
import { authUrl, IResponseDto } from '@r1-frontend/api-domru/esign/v1/esia/authUrl';

import { IS_LOCAL_ENVIROMENT } from '~/src/constants';
import { startGetttingCode, updateError } from '~/src/features/lk/PassportUpdate/store/actions';
import { TAppThunkDispatch } from '~/src/store';

export const defaultOrigin = 'https://perm.dom.ru';

/**
 * Стартует процесс получения кода от Госуслуг
 */
export const startGettingGosuslugiCode = () => async(dispatch: TAppThunkDispatch): Promise<void> => {
    if (!window) {
        return;
    }

    const { origin, pathname } = window.location;

    const returnUrl = IS_LOCAL_ENVIROMENT ? `${defaultOrigin}${pathname}` : `${origin}${pathname}`;

    const response = await doRequest.apiEsign<IResponseDto>(authUrl(returnUrl));

    if (response.isSuccess) {
        window.location.href = response.payload.authUrl;

        dispatch(startGetttingCode());
    } else {
        dispatch(updateError({ errorMessage: response.error.message, isShowPassportUpdateButton: [403, 400].includes(Number(response.error.status)) }));
    }
};
